module.exports = __webpack_public_path__ + "media/images/ohap__Gradebook_Settings-22a02161face0897711f25eb294be5ed.png";